import { BaseUserType } from '../types/authority.types';

export const BASE_USER_TYPE_LABELS: Record<BaseUserType, string> = {
    C: '본사',
    S: '협력사',
    R: '라이더',
};

export const STANDARD_PERMISSION_CODES = ['A', 'C', 'S', 'R'] as const;

export const STANDARD_PERMISSION_LABELS: Record<string, string> = {
    A: '관리자',
    C: '본사',
    S: '협력사',
    R: '라이더',
};

export const STANDARD_PERMISSION_DESCRIPTIONS: Record<string, string> = {
    A: '시스템 전체 관리 권한',
    C: '본사 직원 권한',
    S: '협력사 관리자 권한',
    R: '라이더 기본 권한',
};
